import React, { Fragment } from "react";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast.scss";
// Docs are at https://fkhadra.github.io/react-toastify/

const ToastProvider = ({ children }) => {
  return (
    <Fragment>
      <ToastContainer
        className="toast-full-width"
        position="bottom-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
        transition={Slide}
      />
      {children}
    </Fragment>
  );
};

export default ToastProvider;
